import { lazy } from 'react';

export interface EmojiSelection {
  native: string;
}

/**
 * Emoji picker + its dataset together weigh ~1MB minified. Defer both until
 * the user actually opens a picker so they don't block the main bundle.
 * Shared by the composer (MessageInput) and the reaction picker
 * (ReactionBar) so the chunk is downloaded once and both surfaces stay in
 * step. Render inside a <Suspense>.
 */
export const LazyEmojiPicker = lazy(async () => {
  const [{ default: Picker }, { default: data }] = await Promise.all([
    import('@emoji-mart/react'),
    import('@emoji-mart/data'),
  ]);
  return {
    default: (props: { onEmojiSelect: (emoji: EmojiSelection) => void }) => (
      <Picker
        data={data}
        onEmojiSelect={props.onEmojiSelect}
        theme="light"
        previewPosition="none"
        skinTonePosition="none"
      />
    ),
  };
});
